export default __webpack_public_path__ + "static/media/arrowRight.44a4b33a.svg";